// extracted by mini-css-extract-plugin
module.exports = {"root":"FormNote_root__3hqrz","rootError":"FormNote_rootError__iELUX"};